import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';
import { proposalsAdded, proposalsDeleted } from './proposals';
import moment from 'moment';

const slice = createSlice({
	name: 'proposal',
	initialState: null,
	reducers: {
		proposalSaved: (proposal, action) => action.payload,
		proposalReceived: (proposal, action) => action.payload,
		proposalReseted: () => null,
		proposalCreated: {
			reducer: (proposal, action) => action.payload,
			prepare: event => ({
				payload: {
					sb_id: '',
					user_id: '',
					total_amount: 0.0,
					proposal_type: '',
					duration: 0.0,
					number_of_instalments: 0,
					instalments_amount: 0.0,
					instalments_frequency: '',
					interest_rate: 0.0,
					admin_fee: 0.0,
					status: 'REQUESTED',
					rejected_reasons: [],
					requested_at: moment().utc(true),
					user_approved_at: null,
					became_loan_at: null,
					sb_approved_at: null,
					last_rejected_at: null,
					previous_proposal_id: '',
					loan_id: '',
					created_at: moment().utc(true),
					updated_at: moment().utc(true),
					starting_date: moment().utc(true),
				},
			}),
		},
	},
});

export const deleteProposal = proposalId => (dispatch, getState) => {
	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: `/proposals/${proposalId}`,
			method: 'DELETE',
			onSuccess: proposalsDeleted.type,
		})
	);
};

export const saveProposal = proposal => (dispatch, getState) => {
	let method = '';
	let url = '';
	let onSuccess = '';

	delete proposal.user;
	delete proposal.loan;
	delete proposal.previous_proposal;

	if (proposal.id === undefined) {
		method = 'POST';
		url = '/proposals';
		if (proposal.loan_id === '') proposal.loan_id = null;
		if (proposal.previous_proposal_id === '') proposal.previous_proposal_id = null;
		proposal.requested_at = moment().utc(true);
		proposal.created_at = moment().utc(true);
		proposal.updated_at = moment().utc(true);
		onSuccess = proposalsAdded.type;
	} else {
		// method = 'PUT';
		// url = `/proposals/${proposal.id}`;
		// onSuccess = proposalsUpdated.type;
		// delete proposal.id;
		// proposal.updated_at = moment().utc(true);
		// Object.keys(proposal).forEach(x => {
		// 	proposal[x] === null && delete proposal[x];
		// });
	}

	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url,
			method,
			data: proposal,
			onSuccess,
		})
	);
};

export const { proposalCreated, proposalSaved, proposalReceived, proposalReseted } = slice.actions;

export default slice.reducer;
